export const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.07, delayChildren: 0.15 } },
};

export const charVariants = {
  hidden: { y: "115%", opacity: 0, rotateX: -50 },
  show: {
    y: "0%",
    opacity: 1,
    rotateX: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

export const fadeUp = {
  hidden: { y: 36, opacity: 0 },
  show: (d = 0) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.7, delay: d, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const ROLES = [
  "Frontend Developer",
  "MERN Stack Developer",
  "Full Stack Developer",
];

export const PARTICLES = Array.from({ length: 22 }, (_, i) => ({
  id: i,
  x: `${Math.random() * 100}%`,
  y: `${Math.random() * 100}%`,
  size: Math.random() * 2.5 + 0.5,
  dur: Math.random() * 10 + 7,
  delay: Math.random() * 6,
}));
